import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "open-or-close-summary__day"
}
const _hoisted_2 = {
  key: 1,
  class: "open-or-close-summary__day"
}
const _hoisted_3 = {
  key: 0,
  class: "open-or-close-summary__label"
}
const _hoisted_4 = {
  key: 1,
  class: "open-or-close-summary__hours"
}

import { computed } from 'vue';
  import {
    useOpeningHours,
    formatTimeAmPm,
    formatClosingMessage,
    isPastClosingTime,
    todayDayDisplayName,
    type OpeningHoursItem,
    type OpeningHoursOverride,
  } from '../../modules/utils/useOpeningHours';

  interface Props {
    openingMessage?: string;
    closingMessage?: string;
    summaryLink?: string;
    openingHours?: OpeningHoursItem[];
    openingHoursOverride?: OpeningHoursOverride[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'OpenOrCloseSummary',
  props: {
    openingMessage: { default: '' },
    closingMessage: { default: '' },
    summaryLink: { default: '' },
    openingHours: { default: () => [] },
    openingHoursOverride: { default: () => [] }
  },
  setup(__props: any) {

  const props = __props;

  const { todayDisplay, nextOpenDisplay } = useOpeningHours(
    () => props.openingHours,
    () => props.openingHoursOverride,
  );

  const closedMessage = computed(() =>
    formatClosingMessage(todayDisplay.value?.message || props.closingMessage, nextOpenDisplay.value)
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.summaryLink ? 'a' : 'div'), {
    href: __props.summaryLink || undefined,
    class: "open-or-close-summary"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (_unref(todayDisplay) &&
                      !_unref(todayDisplay).isClosed &&
                      !_unref(isPastClosingTime)(_unref(todayDisplay).closes))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.openingMessage) + " " + _toDisplayString(_unref(formatTimeAmPm)(_unref(todayDisplay).closes)), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_unref(todayDisplay)?.label)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(`${_unref(todayDisplay).label},`), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createTextVNode(" " + _toDisplayString(closedMessage.value) + " ", 1 /* TEXT */),
              (_unref(nextOpenDisplay)?.opens)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(formatTimeAmPm)(_unref(nextOpenDisplay).opens)), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["href"]))
}
}

})